import { render, staticRenderFns } from "./Level4.vue?vue&type=template&id=98c0be64&"
import script from "./Level4.vue?vue&type=script&lang=js&"
export * from "./Level4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports